import React from 'react';
import './DeleteConfirmationModal.css';

const DeleteConfirmationModal = ({ isOpen, onClose, onConfirm, itemName }) => {
    if (!isOpen) return null;

    return (
        <div className="delete-modal-overlay">
            <div className="delete-modal-content">
                <div className="delete-modal-header">
                    <h3>Confirm Delete</h3>
                    <button className="delete-modal-close" onClick={onClose}>&times;</button>
                </div>
                <div className="delete-modal-body">
                    <p>Are you sure you want to delete {itemName ? <strong>{itemName}</strong> : 'this item'}?</p>
                    <p className="delete-modal-warning">This action cannot be undone.</p>
                </div>
                <div className="delete-modal-footer">
                    <button className="delete-modal-cancel-btn" onClick={onClose}>Cancel</button>
                    <button className="delete-modal-confirm-btn" onClick={onConfirm}>Delete</button>
                </div>
            </div>
        </div>
    );
};

export default DeleteConfirmationModal;
